import { render, staticRenderFns } from "./AboutCounters.vue?vue&type=template&id=4bb626bc&"
import script from "./AboutCounters.vue?vue&type=script&lang=js&"
export * from "./AboutCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports